export enum BasicRoutes {
  Home = '/',
  Login = '/login',
  OrganizationUsers = '/organization/roles',
  OrganizationUtilization = '/organization/utilization',
  ProfileGeneral = '/profile/general',
  Projects = '/projects',
  registration = '/sign-up',
}
